<template>
  <div class="page">
    <section class="main-wrap">
      <div class="main-cont clear">
        <div class="main-header">
          <div class="main-h-l">
            <a href="javascript:void(0);" title="返回首页"><img src="../../assets/images/login/wz_logo_c.png" /></a><span>重置密码</span>
          </div>
          <a href="javascript:void(0);" @click="returnIndex" class="main-h-r">回首页看看</a>
        </div>
        <div class="main-form clear">
          <div class="main-f-tit">注册成功</div>
          <div class="pass-step">
            <i></i>
            <p>您的账号创建成功</p>
            <div>
              <a href="javascript:void(0);" @click="returnIndex" class="home">返回首页</a><a href="javascript:void(0);" @click="login">立即登录</a>
            </div>
          </div>
        </div>
        <div class="copy">
          Copyright © 2017-2021 中润普达 －
          <a href="javascript:void(0);" target="_blank">京ICP备2021002262号-1</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import '@/assets/css/login.css'

export default {
  data () {
    return {

    }
  },
  methods: {
    // 返回首页
    returnIndex () {
      this.$router.push('/');
    },
    // 登录
    login () {
      this.$router.push('/login');
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/registerSuccess.vue